import React from 'react';
import { ArrowLeft, Sun, Moon } from 'phosphor-react';
import ProgressBar from '../ui/ProgressBar';

interface RoutineChecklistHeaderProps {
  navigate: (path: string) => void;
  isMorning: boolean;
  completedCount: number;
  total: number;
}

export default function RoutineChecklistHeader({ navigate, isMorning, completedCount, total }: RoutineChecklistHeaderProps) {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-soft dark:border-b dark:border-gray-700 px-5 pt-12 pb-5">
      <div className="max-w-lg mx-auto">
        <button
          onClick={() => navigate('/dashboard')}
          className="mb-3 p-2 -ml-2 text-nude-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-xl transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>

        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
              Executar Rotina
            </h1>
            <p className="text-sm text-nude-500 dark:text-gray-400 mt-0.5">
              Siga as etapas e marque cada uma como concluída
            </p>
          </div>

          <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold
            ${isMorning
              ? 'bg-blush-100 text-blush-600 dark:bg-blush-900/30 dark:text-blush-400'
              : 'bg-lavender-100 text-lavender-600 dark:bg-lavender-900/30 dark:text-lavender-400'
            }`}
          >
            {isMorning ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
            {isMorning ? 'Manhã' : 'Noite'}
          </div>
        </div>

        <div className="mt-4">
          <div className="flex items-center justify-between text-xs text-nude-400 dark:text-gray-500 mb-1">
            <span>{completedCount} de {total} etapas</span>
            <span>{total > 0 ? Math.round((completedCount / total) * 100) : 0}%</span>
          </div>
          <ProgressBar
            valor={total > 0 ? (completedCount / total) * 100 : 0}
            className="h-2"
            barraClassName="bg-blush-400 dark:bg-blush-500"
            label="Etapas concluídas"
          />
        </div>
      </div>
    </header>
  );
}
